export default "__VITE_ASSET__Bt_R6bQP__"